import React from 'react';
import Authorization from 'containers/Authorization';
import { ContextMenu } from 'components';
import propTypes from 'prop-types';
import { BUILDER } from 'shared/abilities';
import style from './DeletedWidget.scss';


const renderDraggableArea = () => (
  <div className={style.deletedWidget}>
    <p>Drag a widget here</p>
  </div>
);

const renderUndraggableArea = position => (
  <ContextMenu
    id={`disabled-widget-${position}`}
    heading="To add a widget here, please contact support."
    menuItems={[]}
  >
    <div className={`${style.deletedWidget} ${style.pointer}`} />
  </ContextMenu>
);

const DeletedWidget = ({ position }) => (
  <Authorization action="manage" subject={BUILDER}>
    {authorized => (authorized ? renderDraggableArea() : renderUndraggableArea(position))}
  </Authorization>
);

DeletedWidget.propTypes = {
  position: propTypes.number,
};

DeletedWidget.defaultProps = {
  position: 0,
};

export default DeletedWidget;
